var Column = function Column() {};
//@todo Pass Parent MetaData

Column.displayName = 'Column';

export { Column };
